<template>
    <button
        :class="newClass"
        :style="{ width, height, backgroundColor, color: textColor }"
        :disabled="disabled"
        @click="e => !disabled && $emit('click', e)"
    >
        <slot />
    </button>
</template>
<script>
export default {
    props: {
        backgroundColor: {
            type: String,
            required: false,
            default: "#878787"
        },
        textColor: {
            type: String,
            required: false,
            default: "#FFF"
        },
        width: {
            type: String,
            required: false
        },
        height: {
            type: String,
            required: false
        },
        size: {
            type: String,
            default: "m"
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        newClass() {
            const { inactiveColor, className, size } = this;
            return [className, inactiveColor && "inactiveColor", size];
        }
    }
};
</script>
<style scoped lang="scss">
button {
    min-width: 70px;
    border: none;
    border-radius: 3px;
    text-transform: uppercase;
    transition: opacity 0.3s ease;
    // m, s, and l define the differents sizes for this button.
    // It works with props. default is m.
    &.xl {
        padding: 20px 25px;
    }
    &.l {
        padding: 10px 18px;
    }
    &.m {
        padding: 6px 12px;
    }
    &.s {
        padding: 5px 10px;
        font-size: 12px;
    }
    &.xs {
        font-size: 0.8em;
        padding: 2px 10px 2px 10px;
    }
    &.inactiveColor {
        background-color: grey;
    }
    &:disabled {
        background-color: grey;
        cursor: no-drop;
    }
    &:hover {
        opacity: 0.8;
    }
}
</style>



// WEBPACK FOOTER //
// ForcastButton.vue?1a41ed77